import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../data/BaseUrl";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const deleteKeyword = createAsyncThunk(
  "api/deleteKeyword",
  async ({ TOKEN, filters }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/wati/delete_predefined_msg${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteKeyword Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deleteIngredient = createAsyncThunk(
  "api/deleteIngredient",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/diet/ingredient/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          // "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteIngredient Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deleteDietTiming = createAsyncThunk(
  "api/deleteDietTiming",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/dietTiming/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteDietTiming Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deleteDietType = createAsyncThunk(
  "api/deleteDietType",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/diettype/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteDietType Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deletePTTrack = createAsyncThunk(
  "api/deletePTTrack",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/ptTrial/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          "deletePTTrack Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deleteDietician = createAsyncThunk(
  "api/deleteDietician",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/dietitian/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteDietician Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deleteDietPackage = createAsyncThunk(
  "api/deleteDietPackage",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/dietcat/new/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteDietPackage Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const deleteDietPlan = createAsyncThunk(
  "api/deleteDietPlan",
  async ({ TOKEN, UID }) => {
    try {
      const apiUrl = `${BASE_URL}/dietpackage/delete?uid=${UID}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          "deleteDietPlan Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const commonDeleteApi = createAsyncThunk(
  "api/delete",
  async ({ TOKEN, endpoint, queryParams }) => {
    try {
      const queryString = queryParams
        ? `?${new URLSearchParams(queryParams).toString()}`
        : "";
      const apiUrl = `${BASE_URL}${endpoint}${queryString}`;

      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          `Request to ${apiUrl} failed with status ${response.status}`
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const delApiSlice = createSlice({
  name: "delApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteKeyword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteKeyword.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteKeyword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteIngredient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteIngredient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteIngredient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteDietTiming.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDietTiming.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteDietTiming.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteDietType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDietType.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteDietType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deletePTTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePTTrack.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deletePTTrack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteDietician.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDietician.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteDietician.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteDietPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDietPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteDietPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteDietPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDietPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteDietPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(commonDeleteApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(commonDeleteApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(commonDeleteApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default delApiSlice.reducer;
export {
  deleteKeyword,
  deleteIngredient,
  deleteDietTiming,
  deleteDietType,
  deletePTTrack,
  deleteDietician,
  deleteDietPackage,
  deleteDietPlan,
  commonDeleteApi,
};